// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"7420640c","199":"a822095a","200":"8140ad3c","407":"89333924","668":"98cab547","693":"2fbfe3e9","976":"1258ae8f"}[chunkId] + ".chunk.js";
};